(() => {
  'use strict';

  const ROOT_SELECTOR = '[data-b1-frame-bandware-option]';

  const money = (cents) => {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency',
        currency: window.Shopify?.currency?.active || 'USD',
        maximumFractionDigits: 2,
      }).format(Number(cents || 0) / 100);
    } catch (_) {
      return `$${(Number(cents || 0) / 100).toFixed(2)}`;
    }
  };

  const presentmentCents = (storeCents) => {
    const rate = Number(window.Shopify?.currency?.rate || 1);
    return Math.round(Number(storeCents || 0) * (Number.isFinite(rate) && rate > 0 ? rate : 1));
  };

  const init = (root) => {
    if (!root || root.dataset.b1BandwareReady === 'true') return;
    root.dataset.b1BandwareReady = 'true';

    const formId = root.dataset.productFormId;
    const form = formId ? document.getElementById(formId) : null;
    const productForm = form?.closest('product-form');
    const productInfo = root.closest('product-info');
    const submitButton = productForm?.querySelector('[type="submit"]');
    const submitLabel = submitButton?.querySelector('span');
    const hiddenInput = root.querySelector('[data-b1-companion-variant-id]');
    const selectedLabel = root.querySelector('[data-b1-bandware-selected-label]');
    const details = root.querySelector('details');
    const notice = root.querySelector('[data-b1-frame-bandware-notice]');
    const choices = Array.from(root.querySelectorAll('[data-b1-bandware-choice]'));
    const completeChoice = choices.find((choice) => choice.dataset.b1BandwareChoice === 'add') || null;

    if (!form || !hiddenInput || !choices.length) return;

    const requestedSet = new URL(window.location.href).searchParams.get('set');
    let mode = requestedSet === 'frame-only' ? 'frame-only' : (root.dataset.defaultMode || 'frame-only');
    let baseButtonLabel = submitLabel?.textContent.trim() || '';
    let currentBasePrice = Number(root.dataset.basePrice || 0);

    const isBundleButtonLabel = (text) => /^(?:ADD|PRE-ORDER)\s+(?:BOTH|SET)\b/i.test(String(text || '').trim());

    const selectedModelSlug = () => {
      const selected = productInfo?.querySelector('[data-interface-model-choice].is-selected');
      return selected?.dataset.modelSlug || new URL(window.location.href).searchParams.get('model') || '';
    };

    const updateColorLinks = () => {
      const setValue = mode === 'add' ? 'complete' : 'frame-only';
      const model = selectedModelSlug();
      root.closest('[data-product-options-stack]')?.querySelectorAll('#swatches a[href]').forEach((anchor) => {
        const raw = anchor.dataset.b1FrameBaseHref || anchor.getAttribute('href');
        if (!raw) return;
        if (!anchor.dataset.b1FrameBaseHref) anchor.dataset.b1FrameBaseHref = raw;
        let url;
        try { url = new URL(anchor.dataset.b1FrameBaseHref, window.location.origin); } catch (_) { return; }
        if (model) url.searchParams.set('model', model); else url.searchParams.delete('model');
        url.searchParams.set('set', setValue);
        url.searchParams.delete('device');
        anchor.setAttribute('href', `${url.pathname}${url.search}${url.hash}`);
      });
    };

    const refreshButtonLabel = () => {
      if (!submitButton || !submitLabel) return;

      if (mode === 'add' && !submitButton.disabled) {
        submitLabel.textContent = root.dataset.addBothLabel || 'ADD BOTH';
      } else if (baseButtonLabel) {
        submitLabel.textContent = baseButtonLabel;
      }
    };


    const selectChoice = (choice) => {
      if (!choice || choice.disabled || choice.getAttribute('aria-disabled') === 'true') return;

      mode = choice.dataset.b1BandwareChoice === 'add' ? 'add' : 'frame-only';
      const companionId = mode === 'add' ? String(choice.dataset.b1BandwareVariantId || '') : '';
      hiddenInput.value = companionId;

      choices.forEach((item) => {
        const selected = item === choice;
        item.classList.toggle('is-selected', selected);
        item.setAttribute('aria-checked', selected ? 'true' : 'false');
        const state = item.querySelector('.b1-frame-bandware-option__choice-state');
        if (!state || item.disabled) return;
        if (selected) state.textContent = 'SELECTED';
        else state.textContent = item.dataset.b1BandwareChoice === 'add' ? 'ADD' : '';
      });

      if (selectedLabel) selectedLabel.textContent = mode === 'add' ? 'FRAME + BANDWARE' : 'FRAME ONLY';

      if (notice) {
        notice.hidden = true;
        notice.textContent = '';
      }

      const url = new URL(window.location.href);
      url.searchParams.set('set', mode === 'add' ? 'complete' : 'frame-only');
      history.replaceState(history.state || {}, '', `${url.pathname}${url.search}${url.hash}`);
      updateColorLinks();

      refreshButtonLabel();
      if (details) details.open = false;

      root.dispatchEvent(new CustomEvent('b1-frame:bandware-change', {
        bubbles: true,
        detail: { mode, companionVariantId: companionId }
      }));
    };

    choices.forEach((choice) => choice.addEventListener('click', () => selectChoice(choice)));
    document.addEventListener('royal-pop:model-change', updateColorLinks);

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, ({ data } = {}) => {
        if (String(data?.sectionId || '') !== String(productForm?.dataset.sectionId || '')) return;

        if (data?.variant?.price != null) currentBasePrice = Number(data.variant.price || 0);

        window.setTimeout(() => {
          const text = submitLabel?.textContent.trim();
          if (text && !isBundleButtonLabel(text)) baseButtonLabel = text;
          refreshButtonLabel();
        }, 0);
      });
    }

    const initialChoice = choices.find((choice) => choice.dataset.b1BandwareChoice === mode && !choice.disabled)
      || choices.find((choice) => choice.dataset.b1BandwareChoice === 'frame-only');
    selectChoice(initialChoice);
  };

  const boot = (scope = document) => scope.querySelectorAll(ROOT_SELECTOR).forEach(init);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot(), { once: true });
  else boot();

  document.addEventListener('shopify:section:load', (event) => boot(event.target));
})();
